// extracted by mini-css-extract-plugin
export default {"investment":"investors_investment__-BI+m","content":"investors_content__U+fGM","title":"investors_title__Enu+m","card":"investors_card__SGnnA"};